import React, { Component } from 'react';
import swal from 'sweetalert';
import SimpleReactValidator from 'simple-react-validator';
import { withNamespaces } from 'react-i18next';

const sleep = (milliseconds) => {
    return new Promise(resolve => setTimeout(resolve, milliseconds))
}
var svValidator;
var engValidator;
class ContactSettingComponent extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isEditable : false,
            editContactNum: false,
            SettingValue: '',
            editDispatcherNum: false,
            editSupportNum: false,
            editSupportEmail: false,
            contactCallingData: {},
            dispatcherCallingData: {},
            supportCallingData: {},
            supportEmailAddressData: {},
            enableDirectCallingData : {},
            editDirectCalling: false,
            checkedCheckbox:false
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleChangeEmail = this.handleChangeEmail.bind(this);
    }
    componentWillMount(){
        SimpleReactValidator.addLocale('en', {
            required : 'The :attribute field is required.',
            min : 'The :attribute must be at least :min:type.',
            max : 'The :attribute may not be greater than :max:type.',
            email : 'The :attribute must be a valid email address.', 
        });
        SimpleReactValidator.addLocale('sv', {
            required : 'Fältet :attribute krävs.',
            min : ':attribute måste vara minst :min tecken.',
            max : ':attribute kanske inte är större än :max tecken.',
            email : 'E-postmeddelandet måste vara en giltig e-postadress.'
        });
        engValidator = new SimpleReactValidator({
            locale : 'en',
            validators: {
              phoneValidation: {
                message: 'The phone must be a valid phone number.',
                rule: (val, params, validator) => {
                  return validator.helpers.testRegex(val,/^(?=.*[0-9])[- +()0-9]+$/) && params.indexOf(val) === -1
                }
              }
            }
        });
        svValidator = new SimpleReactValidator({
            locale : 'sv',
            validators: {
              phoneValidation: {
                message: 'Telefonnummer måste vara ett giltigt telefonnummer.',
                rule: (val, params, validator) => {
                  return validator.helpers.testRegex(val,/^(?=.*[0-9])[- +()0-9]+$/) && params.indexOf(val) === -1
                }
              }
            }
          });
          this.validator = engValidator;
    }
    componentDidUpdate(prevProps) {
        console.log("props", this.props.getAllContactSettingDetails)
        if (prevProps.getAllContactSettingDetails != this.props.getAllContactSettingDetails) {
            this.props.getAllContactSettingDetails.allSetting.forEach(item => {
                if (item.SettingName == "ContactCallingNumber") {
                    this.setState({
                        contactCallingData: item
                    })
                }
                if (item.SettingName == "DispatcherCallingNumber") {
                    this.setState({
                        dispatcherCallingData: item
                    })
                }
                if (item.SettingName == "SupportCallingNumber") {
                    this.setState({
                        supportCallingData: item
                    })
                }
                if (item.SettingName == "SupportEmailAddress") {
                    this.setState({
                        supportEmailAddressData: item
                    })
                }
                if(item.SettingName == "EnableDirectCalling") {
                    this.setState({
                        enableDirectCallingData : item
                    })
                }
            })
        }
    }
    componentWillReceiveProps(nextProps) {
        console.log("next", nextProps);
        if (nextProps.getAllContactSettingDetails.responseValue != this.props.getAllContactSettingDetails.responseValue) {
            if (nextProps.getAllContactSettingDetails.statusCode == 200) {
                swal(nextProps.getAllContactSettingDetails.message, {
                    icon: "success",
                });
                this.setState({ isEditable : false})
                this.props.getAllSettings();
                this.props.clearState();
            }
        }
        this.translateLang();
    }
    translateLang(){
        var language;
        if(sessionStorage.getItem('Language')){
          language = sessionStorage.getItem('Language');
        }
        else{
          language = "en";
        }
        if(language == "en"){
          this.validator = engValidator
        }
        else{
          this.validator = svValidator
        }
    }
    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    }
    handleChangeEmail = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }
    editContact = () => {
        this.setState({
            editContactNum: true,
            isEditable : true,
            SettingValue: this.state.contactCallingData.SettingValue
        });
    };
    saveContactNum = () => {
        if(this.validator.allValid()){
            this.setState({ editContactNum: false });
            this.props.updateContact(this.state.SettingValue);
        }
        else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }
    cancelContactNum = () =>{
        this.setState({editContactNum : false, isEditable : false})
    }
    editDispatcher = () =>{
        this.setState({
            editDispatcherNum: true,
            isEditable : true,
            SettingValue: this.state.dispatcherCallingData.SettingValue
        });
    }
    saveDispatcher = () =>{
        if(this.validator.allValid()){
            this.setState({ editDispatcherNum: false });
            this.props.updateDispatcherNum(this.state.SettingValue);
        }
        else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }
    cancelDispatcher = () =>{
        this.setState({ editDispatcherNum : false,isEditable : false })
    }
    editSupportNumber = () =>{
        this.setState({
            editSupportNum : true,
            isEditable : true,
            SettingValue: this.state.supportCallingData.SettingValue
        });
    }
    saveSupportNumber = () =>{
        if(this.validator.allValid()){
            this.setState({ editSupportNum: false });
            this.props.updateSupportNumber(this.state.SettingValue);
        }
        else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }
    cancelSupportNumber = () =>{
        this.setState({ editSupportNum : false, isEditable : false })
    }
    editSupportEmail = () =>{
        this.setState({
            editSupportEmail: true,
            isEditable : true,
            SettingValue: this.state.supportEmailAddressData.SettingValue
        });
    }
    saveSupportEmail = () =>{
        if(this.validator.allValid()){
            this.setState({ editSupportEmail : false });
            this.props.updateSupportEmail(this.state.SettingValue);
         }
         else{
            this.validator.showMessages();
            this.forceUpdate();
         }
    }
    cancelSupportEmail = () =>{
        this.setState({ editSupportEmail : false,isEditable : false})
    }
    handleCheckbox = (e) =>{
        if(e.target.checked){
            this.setState({ 
                [e.target.name]: "true",
                checkedCheckbox : "true" 
            });
        }
        else{
            this.setState({ 
                [e.target.name]: "false",
                checkedCheckbox : "false"
            });
        }
    }
    editDirectCallingData = () =>{
        this.setState({
            editDirectCalling: true,
            isEditable : true,
            SettingValue: this.state.enableDirectCallingData.SettingValue,
            checkedCheckbox : this.state.enableDirectCallingData.SettingValue
        });
    }
    saveDirectCalling = () =>{
        this.setState({ editDirectCalling: false });
        this.props.updateDirectCalling(this.state.SettingValue);
    }
    cancelDirectCalling = () =>{
        this.setState({ editDirectCalling : false,isEditable : false})
    }
    render() {
        const { t } = this.props;
        return (
            <div className="container">
                <div className="progressbar-heading grids-heading">
                    <h2>{t('Menu.Contact setting')}</h2>
                </div>
                <div className="panel panel-widget forms-panel w3-last-form setting-layout">
                    <div className="setting-data">
                        <div className="row contact-data">
                            <div className="col-md-6">
                                {
                                    this.state.contactCallingData ?
                                        <p className="contact-heading">{this.state.contactCallingData.DisplayName}</p>
                                        : <p></p>
                                }
                                {
                                    this.state.contactCallingData ?
                                        <p className="contact-desc">{this.state.contactCallingData.DisplayDescription}</p>
                                        : <p></p>
                                }
                            </div>
                            <div className="col-md-3">
                                {
                                    this.state.editContactNum ?
                                    <div>
                                        <input className="contact-input"
                                            type="text"
                                            name={'SettingValue'}
                                            value={this.state.SettingValue}
                                            onChange={this.handleChange}
                                        />
                                        {this.validator.message('contact number', this.state.SettingValue, 'required|phoneValidation|min:8|max:15')}
                                    </div>
                                        :
                                        <p>{this.state.contactCallingData.SettingValue}</p>
                                }
                                </div>
                                <div className="col-md-3">
                                {
                                    !this.state.editContactNum ?
                                        <button type="button" className="btn btn-primary"
                                            onClick={this.editContact} disabled={this.state.isEditable}>{t('Alarm Setting.Edit')}</button>
                                        :
                                        <div>
                                            <button type="button" className="btn btn-primary save-btn"
                                            onClick={this.saveContactNum}>{t('Alarm Setting.Save')}</button>
                                            <button type="button" className="btn btn-primary"
                                            onClick={this.cancelContactNum}>{t('Alarm Setting.Cancel')}</button>
                                        </div>
                                }
                            </div>
                        </div>
                        <div className="row contact-data">
                                <div className="col-md-6">
                                {
                                    this.state.dispatcherCallingData ?
                                        <p className="contact-heading">{this.state.dispatcherCallingData.DisplayName}</p>
                                        : <p></p>
                                }
                                {
                                    this.state.dispatcherCallingData ?
                                        <p className="contact-desc">{this.state.dispatcherCallingData.DisplayDescription}</p>
                                        : <p></p>
                                }
                                </div>
                                <div className="col-md-3">
                                {
                                    this.state.editDispatcherNum ?
                                    <div>
                                    <input className="contact-input"
                                            type="text"
                                            name={'SettingValue'}
                                            value={this.state.SettingValue}
                                            onChange={this.handleChange}
                                        />
                                        {this.validator.message('dispatcher number', this.state.SettingValue, 'required|phoneValidation|min:8|max:15')}
                                    </div>
                                        :
                                        <p>{this.state.dispatcherCallingData.SettingValue}</p>
                                }
                                 </div>
                                <div className="col-md-3">
                                {
                                    !this.state.editDispatcherNum ?
                                        <button type="button" className="btn btn-primary"
                                            onClick={this.editDispatcher} disabled={this.state.isEditable}>{t('Alarm Setting.Edit')}</button>
                                        :
                                        <div>
                                            <button type="button" className="btn btn-primary save-btn"
                                                onClick={this.saveDispatcher}>{t('Alarm Setting.Save')}</button>
                                            <button type="button" className="btn btn-primary"
                                                onClick={this.cancelDispatcher}>{t('Alarm Setting.Cancel')}</button>
                                        </div>
                                }
                                </div>
                        </div>
                        <div className="row contact-data">
                                <div className="col-md-6">
                                {
                                    this.state.supportCallingData ?
                                        <p className="contact-heading">{this.state.supportCallingData.DisplayName}</p>
                                        : <p></p>
                                }
                                 {
                                    this.state.supportCallingData ?
                                        <p className="contact-desc">{this.state.supportCallingData.DisplayDescription}</p>
                                        : <p></p>
                                }
                                </div>
                                <div className="col-md-3">
                                {
                                    this.state.editSupportNum ?
                                    <div>
                                        <input className="contact-input"
                                            type="text"
                                            name={'SettingValue'}
                                            value={this.state.SettingValue}
                                            onChange={this.handleChange}
                                        />
                                        {this.validator.message('support number', this.state.SettingValue, 'required|phoneValidation|min:8|max:15')}
                                    </div>
                                        :
                                        <p>{this.state.supportCallingData.SettingValue}</p>
                                }
                                 </div>
                                <div className="col-md-3">
                                {
                                    !this.state.editSupportNum ?
                                        <button type="button" className="btn btn-primary"
                                            onClick={this.editSupportNumber} disabled={this.state.isEditable}>{t('Alarm Setting.Edit')}</button>
                                        :
                                        <div>
                                            <button type="button" className="btn btn-primary save-btn"
                                                onClick={this.saveSupportNumber}>{t('Alarm Setting.Save')}</button>
                                            <button type="button" className="btn btn-primary"
                                                onClick={this.cancelSupportNumber}>{t('Alarm Setting.Cancel')}</button>
                                        </div>
                                }
                                </div>
                        </div>
                        <div className="row contact-data">
                                <div className="col-md-6">
                                {
                                    this.state.supportEmailAddressData ?
                                        <p className="contact-heading">{this.state.supportEmailAddressData.DisplayName}</p>
                                        : <p></p>
                                }
                                  {
                                    this.state.supportEmailAddressData ?
                                        <p className="contact-desc">{this.state.supportEmailAddressData.DisplayDescription}</p>
                                        : <p></p>
                                }
                                </div>
                                <div className="col-md-3">
                                {
                                    this.state.editSupportEmail ?
                                    <div>
                                        <input className="contact-input"
                                            type="text"
                                            name={'SettingValue'}
                                            value={this.state.SettingValue}
                                            onChange={this.handleChangeEmail}
                                        />
                                    {this.validator.message('email', this.state.SettingValue, 'required|email')}
                                    </div>
                                        :
                                        <p>{this.state.supportEmailAddressData.SettingValue}</p>
                                }
                                 </div>
                                <div className="col-md-3">
                                 {
                                    !this.state.editSupportEmail ?
                                        <button type="button" className="btn btn-primary"
                                            onClick={this.editSupportEmail} disabled={this.state.isEditable}>{t('Alarm Setting.Edit')}</button>
                                        :
                                        <div>
                                            <button type="button" className="btn btn-primary save-btn"
                                                onClick={this.saveSupportEmail}>{t('Alarm Setting.Save')}</button>
                                            <button type="button" className="btn btn-primary"
                                                onClick={this.cancelSupportEmail}>{t('Alarm Setting.Cancel')}</button>
                                        </div>
                                }
                                </div>
                        </div>
                        <div className="row contact-data">
                                <div className="col-md-6">
                                {
                                    this.state.enableDirectCallingData ?
                                        <p className="contact-heading">{this.state.enableDirectCallingData.DisplayName}</p>
                                        : <p></p>
                                }
                                  {
                                    this.state.enableDirectCallingData ?
                                        <p className="contact-desc">{this.state.enableDirectCallingData.DisplayDescription}</p>
                                        : <p></p>
                                }
                                </div>
                                <div className="col-md-3">
                                {
                                    this.state.editDirectCalling ?
                                        <input type="checkbox" name={'SettingValue'} value={this.state.SettingValue} 
                                            onChange={this.handleCheckbox} checked={this.state.checkedCheckbox == "true" ? true : false} />
                                        :
                                        <p>{this.state.enableDirectCallingData.SettingValue == "true" ? `${t('First_Responder.Yes')}` : `${t('First_Responder.No')}` }</p>
                                }
                                 </div>
                                <div className="col-md-3">
                                 {
                                    !this.state.editDirectCalling ?
                                        <button type="button" className="btn btn-primary"
                                            onClick={this.editDirectCallingData} disabled={this.state.isEditable}>{t('Alarm Setting.Edit')}</button>
                                        :
                                        <div>
                                            <button type="button" className="btn btn-primary save-btn"
                                                onClick={this.saveDirectCalling}>{t('Alarm Setting.Save')}</button>
                                            <button type="button" className="btn btn-primary"
                                                onClick={this.cancelDirectCalling}>{t('Alarm Setting.Cancel')}</button>
                                        </div>
                                }
                                </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default withNamespaces()(ContactSettingComponent);